import React from 'react';
import { useTranslation } from 'react-i18next';

import { routes } from '../../constants';
import type { IconName } from '../../utils/getMuiIcon';
import searchFiltersToQuery from '../../utils/searchFiltersToQuery';
import searchResultsStorageManager from '../../utils/searchResultsStorageManager';
import useRouter from '../../utils/useRouter';
import Breadcrumbs from '../Breadcrumbs';

const AttachmentsBreadcrumbs = () => {
	const { t } = useTranslation();
	const {
		match: {
			params: { productId },
		},
	} = useRouter();

	const storageSessionSearchFilters = searchResultsStorageManager.getSearchFilters();
	const searchPageUrl = `/${routes.search.root}?${searchFiltersToQuery(storageSessionSearchFilters)}`;

	const basePath = `/${routes.productAttachmentsPage.root}/${productId}`;
	const relativePath = location.pathname.replace(basePath, '').split('/').filter(Boolean);

	const folderLinks = relativePath.map((segment, index) => {
		const decoded = decodeURIComponent(segment);
		const url = `${basePath}/${relativePath.slice(0, index + 1).join('/')}`;
		return {
			title: decoded,
			url: relativePath.length > index + 1 ? url : undefined,
			iconName: 'folderIcon' as IconName,
			iconSx: {
				width: 16,
				height: 16,
			},
		};
	});

	const links = [
		{
			title: t('Search'),
			url: searchPageUrl,
			iconName: 'search' as IconName,
		},
		{
			title: t('Product'),
			url: `/${routes.productPage.root}/${productId}`,
			iconName: 'book' as IconName,
		},
		{
			title: t('Attachments'),
			url:
				folderLinks.length !== 0 ? `/${routes.productAttachmentsPage.root}/${productId}` : undefined,
			iconName: 'attachments' as IconName,
		},
		...folderLinks,
	];
	return <Breadcrumbs links={links} />;
};

export default AttachmentsBreadcrumbs;
